module.exports = __webpack_public_path__ + "img/icon8.580d8ffa.png";